import { history, requestHelper } from '../helpers/index';
import axiosInstance from '../../axios.instance';
import { maestroenv } from '../../helpers/maestroenv';
import { alertActions } from '../actions';

export const licensingService = {
  generateRandomPhrase,
  getCurrentLicense,
  uploadLicense,
  readPublicKey
};

async function generateRandomPhrase() {
  return axiosInstance.get(`${maestroenv.REACT_APP_API_URL}/licensing/random-phrase`)
    .then(response => {
      return (response.data);
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

async function getCurrentLicense() {
  return axiosInstance.get(`${maestroenv.REACT_APP_API_URL}/licensing/current-license`)
    .then(response => {
      return (response.data);
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

async function uploadLicense(uploadFields) {
  return axiosInstance.post(`${maestroenv.REACT_APP_API_URL}/licensing/upload`, {uploadFields})
    .then(response => {
      localStorage.setItem('token', JSON.stringify(response.data.token))
      return (response.data);
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

async function readPublicKey() {
  return axiosInstance.get(`${maestroenv.REACT_APP_API_URL}/licensing/public-key`)
    .then(response => {
      return (response.data);
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}
